// Dependencias generales
import React from "react"
import { useEffect, useState } from 'react'
import '../../css/common.css'
import '../../css/initialConfigStyle.css'
import GeneralInfo from './InitialConfig/GeneralInfo'
import Meteo from './InitialConfig/Meteo'
import FV from './InitialConfig/FV'
import Battery from './InitialConfig/Battery'
import Generator from './InitialConfig/Generator'
import Devices from './InitialConfig/Devices'
import Cars from './InitialConfig/Cars'
import Messaging from './InitialConfig/Messaging'
import WorkflowIlustration from "../../components/InitialConfig/WorkflowIlustration"
import Loader from '../../components/Utils/Loader'
import ShareInstallation from './ShareInstallation/ShareInstallation'
import ReactGA from "react-ga4";

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const getInstallationConfiguration = endpointHelias+"/Helias/V0/Configuration/getInstallationConfiguration"

var initialConfigCommonJS = require("../../js/initialConfigCommon.js")
var generalCommonJS = require("../../js/generalCommon.js")
var dashboardCommonJS = require("../../js/dashboardCommon.js")

// Initial config - Welcome
const InstallationConfigurationOptions = (params) => {
  
  const [selectedConfigOption, setSelectedConfigOption] = useState("")
  const [illustrationElements, setIllustrationElements] = useState([])

  useEffect(() => {    
    dashboardCommonJS.precalentarLambda("getHelias3pCredentials")
    cargaTotalInicialInstallationConfiguration() 
    generalCommonJS.autocierrePrivacidadGoogle()   
        
  }, []);

  function cargaTotalInicialInstallationConfiguration(){
    localStorage.removeItem("currentInstallationConfiguration")
    localStorage.removeItem("configuredApps")

    //Al entrar en configuración fuerzo que al pulsar en inicio refresque toda la página por conflictos de renderizado con las gráficas.
    localStorage.setItem("forceDashboardRefreshOnMenuHomeClick", "true")

    var esPropietario = dashboardCommonJS.comprobarPropiedadInstalacion()

    document.getElementById("loaderGeneralAplicacion").className = document.getElementById("loaderGeneralAplicacion").className.replaceAll(" hidden", "")

    if( (esPropietario) || (generalCommonJS.obtenerEmailUsuario() === "soporte@fevergy.com") || (localStorage.getItem("installationName").split("*")[0].includes("INSTALADOR")) ){
      
      if(localStorage.getItem("installationName").split("*")[0].includes("INSTALADOR")){
        document.getElementById("liMensajeria").className = document.getElementById("liMensajeria").className.replaceAll(" hidden", "") + " hidden"
        document.getElementById("liSharing").className = document.getElementById("liSharing").className.replaceAll(" hidden", "") + " hidden"
        document.getElementById("ulOtherOptions").className = document.getElementById("ulOtherOptions").className.replaceAll(" hidden", "") + " hidden"
      }
      
      if(illustrationElements.length === 0){      
        cargarConfiguracionActualPaso()       
      }
  
      initialConfigCommonJS.cargarOpcionesConfiguracionInstalacion()     
    }

    console.log("Opciones de configuración cargadas correctamente.")    	
  }

  function cargarConfiguracionActualPaso(){

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
    var ongoingInstallationConfigurationID = localStorage.getItem("installationId")    
  
    //Petición de datos para el paso actual
    var jsonPeticion = {
      "accountID": localStorage.getItem("accountID"),
      "installationID": ongoingInstallationConfigurationID,
      "GeneralInfo": "",    
      "Meteo": "",  
      "FV": "",
      "Battery": "",
      "Generator": "",
      "Cars": "",
      "Messaging": ""
    }
  
    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", getInstallationConfiguration, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonPeticion);
      xhttp.onreadystatechange = function() {
        
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuesta = JSON.parse(this.responseText)
          if(jsonRespuesta.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
          }
          else{         

            if(jsonRespuesta.body !== undefined){
              setIllustrationElements(initialConfigCommonJS.cargaInicialIlustracion(jsonRespuesta.body))

              localStorage.setItem("currentInstallationConfiguration",JSON.stringify(jsonRespuesta.body))

            }

            if( (typeof(params.selectedOption) !== "undefined") && (params.selectedOption !== "") ){
              seleccionarOpcion(params.selectedOption)              
            }

            //Si no hay datos configurados entonces no hago nada
  
            document.getElementById("loaderGeneralAplicacion").className = document.getElementById("loaderGeneralAplicacion").className.replaceAll(" hidden", "") + " hidden"

            console.log("Información cargada correctamente")
          }
        }
  
        if (this.readyState === 4 && this.status !== 200) {  
          initialConfigCommonJS.mostrarMensajeInformativo('Se produjo un error al cargar la configuracion.',"negative")
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
        }
      }
      xhttp.send(data);      
  }

  function crearInstalacion(){    

    generalCommonJS.registrarEventoAnalitica(ReactGA, 'CONFIGURACIÓN', 'CONFIG. - Crear instalación', "", "")

    localStorage.removeItem("lastAccess")
    localStorage.removeItem("installationConfigurationMode")    
    localStorage.removeItem("installationId")        
    localStorage.setItem("customizedWorkflow","")			      
    localStorage.setItem("installationName","")			          
		localStorage.setItem("ongoingInstallationConfiguration","NEW")
    
    localStorage.setItem("currentInstallations",parseInt(localStorage.getItem("currentInstallations"))+1)			      

		window.location.href="../UserInitialConfig/Welcome"
  }

  function mensajeConfimacionCrearInstalacion(){
    
    initialConfigCommonJS.mostrarMensajeConfirmacionAltaInstalacion("info","AÑADIR OTRA INSTALACIÓN", "¿Seguro que quieres continuar?", crearInstalacion, initialConfigCommonJS.cerrarMensajeBorrado)          
	
  }

  function mensajeConfimacionReiniciarInstalacion(){
    
    var nombreInstalacion = document.getElementById("nombreInstalacionActual").innerHTML

    generalCommonJS.registrarEventoAnalitica(ReactGA, 'CONFIGURACIÓN', 'CONFIG. - Reiniciar instalación', "", "")

    initialConfigCommonJS.mostrarMensajeConfirmacionBorrado("warning","REINICIAR ESTA INSTALACIÓN", "¿Estás seguro de que quieres reiniciar tu instalación "+nombreInstalacion+"? Se borrarán tus datos de consumo, histórico de datos, actividad, informes mensuales y tus reglas, el resto permanecerá igual.", initialConfigCommonJS.reiniciarInstalacion, initialConfigCommonJS.cerrarMensajeBorrado)          
	
  }

  function mensajeConfimacionEliminarInstalacion(){
         
    var nombreInstalacion = document.getElementById("nombreInstalacionActual").innerHTML

    generalCommonJS.registrarEventoAnalitica(ReactGA, 'CONFIGURACIÓN', 'CONFIG. - Borrar instalación', "", "")

    initialConfigCommonJS.mostrarMensajeConfirmacionBorrado("delete","BORRADO DE INSTALACIÓN", "¿Estás seguro de que quieres borrar tu instalación "+nombreInstalacion+" ?", initialConfigCommonJS.eliminarInstalacion, initialConfigCommonJS.cerrarMensajeBorrado)          
	
  }

  function seleccionarOpcion(opcion){

    localStorage.setItem("ongoingInstallationConfiguration",localStorage.getItem("installationId"))
    localStorage.setItem("installationConfigurationMode","true")    

    document.getElementById("asideDetalleConfiguracion").className = document.getElementById("asideDetalleConfiguracion").className.replace(" hidden", "")

    document.getElementById("contenedorPrincipalOpcion").scrollTop = 0

    var componente = ""
    var tituloDetalle = ""
    var iconoDetalle = ""

    if(opcion==="GeneralInfo"){ 
      componente = <GeneralInfo/> 
      tituloDetalle  = "Configuración general"
      iconoDetalle = "analytics"
      generalCommonJS.registrarEventoAnalitica(ReactGA, 'CONFIGURACIÓN', 'CONFIG. - '+tituloDetalle, "", "")
    }
    else if(opcion==="Meteo"){ 
      componente = <Meteo/> 
      tituloDetalle  = "Información meteorológica"
      iconoDetalle = "brightness_4"
      generalCommonJS.registrarEventoAnalitica(ReactGA, 'CONFIGURACIÓN', 'CONFIG. - '+tituloDetalle, "", "")
    }
    else if(opcion==="Messaging"){ 
      componente = <Messaging/> 
      tituloDetalle  = "Mensajería y Alexa"
      iconoDetalle = "mail"
      generalCommonJS.registrarEventoAnalitica(ReactGA, 'CONFIGURACIÓN', 'CONFIG. - '+tituloDetalle, "", "")
    }
    else if(opcion==="FV"){ 
      componente = <FV/> 
      tituloDetalle  = "Paneles solares"
      iconoDetalle = "solar_power"
      generalCommonJS.registrarEventoAnalitica(ReactGA, 'CONFIGURACIÓN', 'CONFIG. - '+tituloDetalle, "", "")
    }
    else if(opcion==="Battery"){ 
      componente = <Battery/> 
      tituloDetalle  = "Baterías"
      iconoDetalle = "battery_std"
      generalCommonJS.registrarEventoAnalitica(ReactGA, 'CONFIGURACIÓN', 'CONFIG. - '+tituloDetalle, "", "")
    }
    else if(opcion==="Generator"){ 
      componente = <Generator/> 
      tituloDetalle  = "Grupo electrógeno"
      iconoDetalle = "dynamic_form"
      generalCommonJS.registrarEventoAnalitica(ReactGA, 'CONFIGURACIÓN', 'CONFIG. - '+tituloDetalle, "", "")
    }
    else if(opcion==="Cars"){ 
      componente = <Cars/> 
      tituloDetalle  = "Coche"
      iconoDetalle = "directions_car"
      generalCommonJS.registrarEventoAnalitica(ReactGA, 'CONFIGURACIÓN', 'CONFIG. - '+tituloDetalle, "", "")
    }
    else if(opcion==="Devices"){ 
      componente = <Devices/> 
      tituloDetalle  = "Dispositivos inteligentes"
      iconoDetalle = "devices_other"
      generalCommonJS.registrarEventoAnalitica(ReactGA, 'CONFIGURACIÓN', 'CONFIG. - '+tituloDetalle, "", "")
    }    
    else if(opcion==="Sharing"){ 
      componente = <ShareInstallation seleccionarOpcion={seleccionarOpcion}/> 
      tituloDetalle  = "Compartición actual"
      iconoDetalle = "share"
      generalCommonJS.registrarEventoAnalitica(ReactGA, 'CONFIGURACIÓN', 'CONFIG. - '+tituloDetalle, "", "")
    }
    
    document.getElementById("iconoDetalleConfiguracion").innerHTML = iconoDetalle
    document.getElementById("tituloDetalleConfiguracion").innerHTML = tituloDetalle

    setSelectedConfigOption(componente)     
  }

  function gestionarVisibilidadDetalleConfiguracion(event){        
    if ( (document.getElementById("asideDetalleConfiguracion") !== null) && !document.getElementById("asideDetalleConfiguracion").className.includes("hidden") && (event.target.id === "asideDetalleConfiguracion") ){            
      volver()
    }
  }

  function volver(){
    document.getElementById("asideDetalleConfiguracion").className = document.getElementById("asideDetalleConfiguracion").className.replaceAll(" hidden", "") + " hidden"

    if(document.getElementById("sharingOptions") !== null){
      document.getElementById("sharingOptions").className = document.getElementById("sharingOptions").className.replaceAll(" hidden", "")
    }
    
    if(document.getElementById("textoBuscador") !== null){
      document.getElementById("textoBuscador").value = ""

      if(document.getElementById("resultadoBusqueda") !== null){
        document.getElementById("resultadoBusqueda").className += " hidden"
      }            

      if(document.getElementById("divSinResultadosInstaladores") !== null){
        document.getElementById("divSinResultadosInstaladores").className += " hidden"
      }            
    }

    if( (typeof(params.selectedOption) !== "undefined") && (params.selectedOption !== "") ){
      window.location = "/InstallationConfiguration"
    }
    
  }
  
  return (      
    
    <>
        <section id="seleccionOpcionConfiguracion" className="step wrapper config gap-08" style={{position: "relative", paddingTop: "14px"}}>
                 
          <div className="content-wrapper horizontal">


            <div id="divOpcionesConfiguracion" className="content-wrapper col-md-12 col-lg-4">                    

                <ul aria-label="Configuración de esta instalación" className="vertical gap-02">

                  <li>
                      <button className="selection icon-wrapper" onClick={() => seleccionarOpcion("GeneralInfo")}>
                      <figure className="avatar size-m cyan"><span className="material-icon">analytics</span></figure>
                      <span className="label">Configuración general</span>
                      </button>
                  </li>
                  <li>
                      <button className="selection icon-wrapper" onClick={() => seleccionarOpcion("Meteo")}>
                      <figure className="avatar size-m cyan"><span className="material-icon">brightness_4</span></figure>
                      <span className="label">Estación meteorológica</span>
                      </button>
                  </li>
                  <li>
                      <button id="botonPanelesSolares" className="selection horizontal no-icon" onClick={() => seleccionarOpcion("FV")}>
                      <figure id="figuraPanelesSolares" className="avatar size-m"><span className="material-icon">solar_power</span></figure>
                      <span className="label">Paneles solares</span>                    
                      <span id="spanAñadirPaneles" className="link">Añadir</span>
                      </button>
                  </li>
                  <li>
                      <button id="botonBaterias" className="selection horizontal no-icon" onClick={() => seleccionarOpcion("Battery")}>
                      <figure id="figuraBaterias" className="avatar size-m"><span className="material-icon">battery_std</span></figure>
                      <span className="label">Baterías</span>                    
                      <span id="spanAñadirBaterias" className="link">Añadir</span>
                      </button>
                  </li>
                  <li>
                      <button id="botonGrupoElectrogeno" className="selection horizontal no-icon" onClick={() => seleccionarOpcion("Generator")}>
                      <figure id="figuraGrupoElectrogeno" className="avatar size-m"><span className="material-icon">dynamic_form</span></figure>
                      <span className="label">Grupo electrógeno</span>                    
                      <span id="spanAñadirGrupoElectrogeno" className="link">Añadir</span>
                      </button>
                  </li>
                  <li>
                      <button id="botonCoche" className="selection horizontal no-icon" onClick={() => seleccionarOpcion("Cars")}>
                      <figure id="figuraCoche" className="avatar size-m"><span className="material-icon">directions_car</span></figure>
                      <span className="label">Coche</span>
                      <span id="spanAñadirCoche" className="link">Añadir</span>
                      </button>
                  </li>
                  <li>
                      <button id="botonDispositivosInteligentes" className="selection horizontal no-icon" onClick={() => seleccionarOpcion("Devices")}>
                      <figure id="figuraDispositivosInteligentes" className="avatar size-m"><span className="material-icon">devices_other</span></figure>
                      <span className="label">Dispositivos inteligentes</span>                    
                      <span id="spanAñadirDispositivosInteligentes" className="link">Añadir</span>
                      </button>
                  </li>
                  <li id="liMensajeria">
                      <button className="selection icon-wrapper" onClick={() => seleccionarOpcion("Messaging")}>
                      <figure className="avatar size-m cyan"><span className="material-icon">mail</span></figure>
                      <span className="label">Mensajería y Alexa</span>
                      </button>
                  </li>

                  <li id="liSharing">
                    <button className="forward icon-wrapper no-icon" onClick={() => seleccionarOpcion("Sharing")}>
                        <figure className="avatar size-m cyan"><span className="material-icon">share</span></figure>
                        <span className="label">Compartir / descompartir</span>
                    </button>
                  </li>

                </ul>

                <ul id="ulOtherOptions" aria-label="Otras acciones" className="vertical gap-02">                  

                  {/*
                  <li>
                    <button className="forward icon-wrapper no-icon" onClick={() => mensajeConfimacionCrearInstalacion()}>
                        <figure className="avatar size-m green"><span className="material-icon">add</span></figure>
                        <span className="label">Añadir nueva instalación</span>
                    </button>
                  </li>                  
                  */}
                  
                  <li>
                    <button className="forward icon-wrapper no-icon" onClick={() => mensajeConfimacionReiniciarInstalacion()}>
                        <figure className="avatar size-m pink"><span className="material-icon">restart_alt</span></figure>
                        <span className="label">Reiniciar esta instalación</span>
                    </button>
                  </li>

                  { localStorage.getItem("availableInstallations").split("|").length > 1 ?
                      <li>
                        <button className="forward icon-wrapper no-icon" onClick={() => mensajeConfimacionEliminarInstalacion()}>
                          <figure className="avatar size-m red"><span className="material-icon">delete</span></figure>
                          <span className="label">Eliminar esta instalación</span>
                        </button>
                      </li>
                  : 
                      <></>
                  }
                                    
                </ul> 

            </div>

            <WorkflowIlustration illustrationElements={illustrationElements}/>

          </div>
        </section>

        <aside id="asideDetalleConfiguracion" className="modal lateral-detail rules hidden" onMouseDown={gestionarVisibilidadDetalleConfiguracion}>

          <div id="contenedorPrincipalOpcion" className="modal-content">

            <button className="link close" onClick={() => volver()}><span className="material-icon">highlight_off</span></button>
            <div className="page">

              <section id="detalleConfiguracion" className="cyan" style={{paddingLeft: "-50px"}}>

                <div id="divDetalleConfiguracion" className="content-wrapper">

                  <header className="horizontal center gap-04">                                
                    <figure id="figureDetalleConfiguracion" className="avatar size-xl">
                      <span id="iconoDetalleConfiguracion" className="material-icon">tune</span>
                    </figure>
                    <dl className="vertical fill">
                      <dd id="tituloDetalleConfiguracion" className="headline-02"></dd>
                    </dl>
                  </header>   

                  {selectedConfigOption}
                
                </div>
                
              </section>

            </div>
          
            <Loader Id="loaderDetalleInstallationConfiguration" Mensaje=""/>

          </div>

        </aside>

    </>
  )
}

export default InstallationConfigurationOptions